import { ADD_PRODUCT, DECREMENT_PRODUCT, INCREMENT_PRODUCT } from "./actionType";

const initialState = {
    products: [
        {
            id: 1,
            name: "Asus Vivobook X515MA",
            price: 35500,
            quantity: 20,
        },
        {
            id: 2,
            name: "Dell E1916HV 18.5 Inch",
            price: 9300,
            quantity: 35,
        },
        {
            id: 3,
            name: "Canon Eos 4000D 18MP",
            price: 200000,
            quantity: 72,
        },
    ],
    cart: [],
};

const productReducer = (state = initialState, action) => {
    state = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case INCREMENT_PRODUCT:
            {
                const product = action.payload;
                const itemOnCart = state.cart.find((item) => item.id === product.id);
                const itemOnProducts = state.products.find((item) => item.id === product.id);
                if (itemOnCart && itemOnProducts) {
                    itemOnCart.quantity = itemOnCart.quantity + 1;
                    itemOnProducts.quantity = itemOnProducts.quantity - 1;
                }
                else {
                    return state;
                }
                return state;
            }
        case ADD_PRODUCT:
            {
                const product = action.payload;
                state.products.forEach((item) => {
                    if (item.id === product.id) {
                        item.quantity = item.quantity - 1;
                    }
                });
                const isExist = state.cart.find((item) => item.id === product.id);
                if (!isExist) {
                    const newProduct = { ...product, quantity: 1 };
                    state.cart.push(newProduct);
                }
                else {
                    isExist.quantity = isExist.quantity + 1;
                }
                return state;
            }
        case DECREMENT_PRODUCT:
            const product = action.payload;
            const itemOnCart = state.cart.find((item) => item.id === product.id);
            const itemOnProducts = state.products.find((item) => item.id === product.id);
            if (itemOnCart && itemOnProducts) {
                itemOnCart.quantity = itemOnCart.quantity - 1;
                itemOnProducts.quantity = itemOnProducts.quantity + 1;
                if (itemOnCart.quantity === 0) {
                    state.cart.splice(state.cart.indexOf(itemOnCart), 1);
                }
            }
            else {
                return state;
            }
            return state;
        default:
            return state;
    }
}

export default productReducer;